import * as go from 'gojs';

/**
 * Die GoJS-Lizenz des Hauses.
 *
 * Derselbe Schlüssel wie in afvis-client und gesa-client — die Lizenz gilt für das Unternehmen,
 * nicht je Anwendung. Ohne ihn zeichnet GoJS ein Wasserzeichen über jedes Diagramm.
 *
 * Der Schlüssel steht bewusst im Quelltext und nicht in einer Umgebungsvariablen: GoJS wertet ihn
 * im Browser aus, er landet also ohnehin im ausgelieferten Bündel. Ihn zu verstecken erzeugte nur
 * den Anschein von Geheimhaltung — er ist an die Domain gebunden und für Dritte wertlos. Anders
 * als ein API-Schlüssel, der niemals in den Client gehört.
 *
 * Wird beim Start einmal ausgeführt; siehe {@link file://./index.tsx}.
 */
(go.Diagram as unknown as { licenseKey: string }).licenseKey =
    '2bf810e4e76f58c517a50e21453065f919a07567c98118a7580315e6fd0a60447199ed2c0180d8c786fd4dee0a'
    + '7a9489ddc53a7ac31c5038e23187d516e787f0b03323b51409468bac007190cefe2af6fc7b74f5c4bc22f0da7'
    + '98fa1e8adc79c5fecf28449990ebe797e00345178fd18b3e9c97dac52ca4f393d99b5eae8';

export {};
